import React, { useState } from 'react';
import { Leaf, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
function PolicyModal({
  title,
  content,
  onClose
}: {
  title: string;
  content: React.ReactNode;
  onClose: () => void;
}) {
  return <AnimatePresence data-id="element-52">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-54">
          <div className="sticky top-0 bg-white border-b border-sage-light/30 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-55">
            <h2 className="text-xl font-serif font-bold text-primary-dark" data-id="element-56">
              {title}
            </h2>
            <button onClick={onClose} className="p-2 rounded-full hover:bg-cream-dark transition-colors text-charcoal/60 hover:text-charcoal" data-id="element-57">
              <X size={20} data-id="element-58" />
            </button>
          </div>
          <div className="px-6 py-6 text-charcoal/80 text-sm leading-relaxed space-y-4" data-id="element-59">
            {content}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}
const privacyContent = <>
    <p data-id="element-60">
      <strong data-id="element-61">Last updated:</strong>{' '}
      {new Date().toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    })}
    </p>
    <p data-id="element-62">
      Your privacy is important to us. This Privacy Policy explains how The
      Supplement Blueprint collects, uses, and protects your personal
      information.
    </p>
    <h3 className="font-serif font-bold text-charcoal text-base pt-2" data-id="element-63">
      Information We Collect
    </h3>
    <p data-id="element-64">
      We may collect personal information that you voluntarily provide when
      purchasing our guide or contacting us, including your name, email address,
      and payment information.
    </p>
    <h3 className="font-serif font-bold text-charcoal text-base pt-2" data-id="element-65">
      How We Use Your Information
    </h3>
    <p data-id="element-66">
      We use your information to process your purchase, deliver the digital
      product, respond to inquiries, and improve our services. We do not sell,
      rent, or share your personal information with third parties for marketing
      purposes.
    </p>
    <h3 className="font-serif font-bold text-charcoal text-base pt-2" data-id="element-67">
      Data Security
    </h3>
    <p data-id="element-68">
      We implement reasonable security measures to protect your personal
      information. However, no method of transmission over the internet is 100%
      secure.
    </p>
    <h3 className="font-serif font-bold text-charcoal text-base pt-2" data-id="element-69">
      Cookies
    </h3>
    <p data-id="element-70">
      Our website may use cookies to enhance your browsing experience. You can
      choose to disable cookies through your browser settings.
    </p>
    <h3 className="font-serif font-bold text-charcoal text-base pt-2" data-id="element-71">
      Changes to This Policy
    </h3>
    <p data-id="element-72">
      We reserve the right to update this Privacy Policy at any time. Changes
      will be posted on this page with an updated revision date.
    </p>
    <h3 className="font-serif font-bold text-charcoal text-base pt-2" data-id="element-73">
      Contact
    </h3>
    <p data-id="element-74">
      If you have questions about this Privacy Policy, please contact us via the
      information provided on our website.
    </p>
  </>;
const termsContent = <>
    <p data-id="element-75">
      <strong data-id="element-76">Last updated:</strong>{' '}
      {new Date().toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    })}
    </p>
    <p data-id="element-77">
      By purchasing or using The Supplement Blueprint, you agree to the
      following terms and conditions.
    </p>
    <h3 className="font-serif font-bold text-charcoal text-base pt-2" data-id="element-78">
      Digital Product
    </h3>
    <p data-id="element-79">
      The Supplement Blueprint is a digital informational guide. Upon purchase,
      you will receive instant access to the guide and any included bonuses.
    </p>
    <h3 className="font-serif font-bold text-charcoal text-base pt-2" data-id="element-80">
      Educational Purposes Only
    </h3>
    <p data-id="element-81">
      This guide is for educational and informational purposes only. It is not
      intended to diagnose, treat, cure, or prevent any disease. Always consult
      with a qualified healthcare professional before starting any new
      supplement routine.
    </p>
    <h3 className="font-serif font-bold text-charcoal text-base pt-2" data-id="element-82">
      Intellectual Property
    </h3>
    <p data-id="element-83">
      All content in The Supplement Blueprint is protected by copyright. You may
      not reproduce, distribute, or resell any part of this guide without
      written permission.
    </p>
    <h3 className="font-serif font-bold text-charcoal text-base pt-2" data-id="element-84">
      Refund Policy
    </h3>
    <p data-id="element-85">
      Due to the digital nature of this product, all sales are final. If you
      experience any issues with your purchase, please contact us and we will do
      our best to resolve them.
    </p>
    <h3 className="font-serif font-bold text-charcoal text-base pt-2" data-id="element-86">
      Limitation of Liability
    </h3>
    <p data-id="element-87">
      The Supplement Blueprint and its creator are not liable for any damages or
      adverse effects resulting from the use of information provided in this
      guide.
    </p>
    <h3 className="font-serif font-bold text-charcoal text-base pt-2" data-id="element-88">
      Changes to Terms
    </h3>
    <p data-id="element-89">
      We reserve the right to modify these terms at any time. Continued use of
      the product constitutes acceptance of updated terms.
    </p>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-primary-dark text-cream/60 py-12 text-center border-t border-white/10" data-id="element-90">
        <div className="max-w-5xl mx-auto px-6 flex flex-col items-center gap-6" data-id="element-91">
          <div className="flex items-center gap-2 text-sage-light opacity-80" data-id="element-92">
            <Leaf size={20} data-id="element-93" />
            <span className="font-serif font-semibold text-lg tracking-wide" data-id="element-94">
              The Supplement Blueprint
            </span>
          </div>

          <p className="text-sm max-w-md mx-auto" data-id="element-95">
            Disclaimer: This guide is for educational purposes only and does not
            replace professional medical advice. Always consult with a
            healthcare provider before starting any new supplement routine.
          </p>

          <div className="flex items-center gap-6 text-sm mt-2" data-id="element-96">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-97">
              Privacy Policy
            </button>
            <span className="w-1 h-1 rounded-full bg-cream/30" data-id="element-98"></span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-99">
              Terms & Conditions
            </button>
          </div>

          <p className="text-xs mt-4 opacity-50" data-id="element-100">
            &copy; {new Date().getFullYear()} The Supplement Blueprint. All
            rights reserved.
          </p>
        </div>
      </footer>

      {activeModal === 'privacy' && <PolicyModal title="Privacy Policy" content={privacyContent} onClose={() => setActiveModal(null)} data-id="element-101" />}
      {activeModal === 'terms' && <PolicyModal title="Terms & Conditions" content={termsContent} onClose={() => setActiveModal(null)} data-id="element-102" />}
    </>;
}